'use client';

import React, { createContext, useContext } from 'react';
import type { PageUrlMap } from '@/types/blog';

export interface PageUrlsContextValue {
  pageUrls?: PageUrlMap;
  defaultLanguage?: string;
}

const PageUrlsContext = createContext<PageUrlsContextValue | undefined>(undefined);

interface PageUrlsProviderProps {
  value?: PageUrlMap | PageUrlsContextValue;
  children: React.ReactNode;
}

/** value olarak { pageUrls, defaultLanguage } veya sadece pageUrls (geriye uyumluluk) verilebilir */
export function PageUrlsProvider({ value, children }: PageUrlsProviderProps) {
  const contextValue: PageUrlsContextValue = !value
    ? {}
    : typeof value === 'object' && ('pageUrls' in value || 'defaultLanguage' in value)
      ? (value as PageUrlsContextValue)
      : { pageUrls: value as PageUrlMap };
  return (
    <PageUrlsContext.Provider value={contextValue}>{children}</PageUrlsContext.Provider>
  );
}

export function usePageUrls(): PageUrlMap | undefined {
  return useContext(PageUrlsContext)?.pageUrls;
}

/** Menü ile aynı davranış için varsayılan dil (varsayılan dilde URL'de /en/ veya /tr/ olmaz) */
export function useDefaultLanguage(): string | undefined {
  return useContext(PageUrlsContext)?.defaultLanguage;
}
